<template>
  <footer id='Main-Footer' v-if='kirby.site.content'>
    <section class='information'>
      <nav>
        <h6 class='title' v-html='kirby.site.content.contacttitle.value' />
        <div v-html='kirby.site.content.contactcontent.value' />
      </nav>
      <nav>
        <h6 class='title' v-html='kirby.site.content.socialmediatitle.value' />
        <div v-html='kirby.site.content.socialmediacontent.value' />
      </nav>
    </section>
    <section id="Footer-Logos" class='logos'>
      <nav class="organizer logos">
        <h6 class='title' v-html='kirby.site.content.organizertitle.value' />
        <a target='_blank' :href='organizerlogo.url' v-for='organizerlogo in yaml(kirby.site.strings.organizerlogos)'>
          <figure v-html='organizerlogo.logo' />
        </a>
      </nav>
      <nav class="partner logos">
        <h6 class='title' v-html='kirby.site.content.partnertitle.value' />
        <a target='_blank' :href='organizerlogo.url' v-for='organizerlogo in yaml(kirby.site.strings.partnerlogos)'>
          <figure v-html='organizerlogo.logo' />
        </a>
      </nav>
      <nav class="supporter logos">
        <h6 class='title' v-html='kirby.site.content.supportertitle.value' />
        <a target='_blank' :href='organizerlogo.url' v-for='organizerlogo in yaml(kirby.site.strings.supporterlogos)'>
          <figure v-html='organizerlogo.logo' />
        </a>
      </nav>
      <nav class="partneringfestival logos" v-if='kirby.site.content.partneringfestivaltitle'>
        <h6 class='title' v-html='kirby.site.content.partneringfestivaltitle.value' />
        <a target='_blank' :href='organizerlogo.url' v-for='organizerlogo in yaml(kirby.site.strings.partneringfestivallogos)'>
          <figure v-html='organizerlogo.logo' />
        </a>
      </nav>
    </section>
  </footer>
</template>

<script>
import mixins from '.././mixins.js';

export default {
  mixins: [mixins], //kirby(), urltopath(), etc
}
</script>

<style scoped>

  footer {
    width: var(--oversize);
    border-top: var(--thinline);
    margin-top: 12rem;
    padding-top: 2rem;
    display: flex;
    flex-direction: var(--columndirection);
    font-size: 0.85rem;
  }

  nav {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 3em;
  }

  nav a {
    box-sizing: border-box;
    margin-right: 3rem;
    margin-bottom: 3rem;
  }

  h6.title {
    font-size: inherit;
    font-weight: inherit;
    width: 100%;
    text-transform: uppercase;
    margin-bottom: 2em;
  }

  figure {
    display: block;
    width: auto;
    overflow: hidden;
  }

  svg {
    display: block;
  }

  section {
    color: var(--gray);
  }

  section.information {
    width: 30%;
  }

  section.logos {
    width: 70%;
    display: flex;
    flex-direction: var(--columndirection);
    flex-wrap: wrap;
    gap: 0 5em;
  }

  nav.organizer.logos {
    width: 40%;
  }

  nav.partner.logos {
    width: 40%;
  }

  nav.supporter.logos {
    width: 70%;
  }

  @media screen and (max-width: 700px) {
    section.logos {
      width: 100% !important;
    }
    nav.logos {
      width: 100% !important;
    }
    nav.logos a {

    }
  }

  @media screen and (max-width: 700px) {
    ul.logos {
        width: auto !important;
    }
  }

</style>

<style>

  footer#Main-Footer a {
    text-decoration: inherit;
  }

  section#Footer-Logos svg {
    height: 4rem;
    max-width: 7rem;
  }

  section#Footer-Logos svg * {
    fill: var(--gray);
  }

  section#Footer-Logos nav.organizer svg {
    max-width: 21rem;
  }
</style>
